module.exports = __webpack_public_path__ + "img/profile-pic.930d9b57.webp";